import { SVGProps } from 'react';

const SvgPersonCheck = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 9" {...props}>
        <path d="m9.282 4.628.718.723-3.349 3.38-1.78-1.795.719-.723L6.65 7.28l2.631-2.652ZM4.102.27a2.051 2.051 0 1 1 0 4.103 2.051 2.051 0 0 1 0-4.103Zm0 1.026a1.026 1.026 0 1 0 0 2.051 1.026 1.026 0 0 0 0-2.051Zm0 3.59c.35 0 .77.046 1.236.133l-.856.856-.38-.015c-1.523 0-3.128.749-3.128 1.077V7.5h3.18l.974.974H0V6.936c0-1.364 2.733-2.051 4.103-2.051Z" />
    </svg>
);
export default SvgPersonCheck;
